/*
 * @Author: xmy233
 * @Date: 2021-02-21 10:16:29
 * @LastEditors: xmy233
 * @LastEditTime: 2021-08-30 11:23:45
 * @Description: file content
 */
import axios from "axios";
import qs from "qs";
// import { Loading} from 'element-ui';
import { ElMessage } from 'element-plus'
import router from '../router'
import {getToken} from '@/utils/util'


axios.defaults.headers.get['Content-Type'] = 'application/json;charset=UTF-8';
axios.defaults.baseURL=process.env.VUE_APP_BASE_URL;


// const loading = {
//   loadingInstance:null,
//   open(){
//     this.loadingInstance = Loading.service({
//       text:"数据加载中"
//     })
//   },
//   close(){
//     this.loadingInstance.close()
//   }
// }

export default function(options:any){
  const instance = axios.create({
  
  })

//http request 拦截器
instance.interceptors.request.use(
  config => {
    // loading.open()
    config.data.Token = getToken()
    config.data = qs.stringify({ "": JSON.stringify(config.data) })
    
    return config;
  },
  err => {
    return Promise.reject(err);
  }
);

instance.interceptors.response.use(res =>{

  const resp = res.data
  // if(loading.loadingInstance !== null){
  //   loading.close()
  //   loading.loadingInstance = null
  // }
  
  if(resp.state === 1004){
    ElMessage({
      message:resp.msg,
      type:"error",
    })
    router.push({ path: '/login' })
  }
  if(resp.state !== 0){
    ElMessage({
      message:resp.msg,
      type:"error",
    })
  }
  return resp;
},error=>{
  if (error){
    ElMessage.error('网络错误，请刷新重试或联系管理员')
  }
  return error
})
return instance(options)
}